import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
	Dialog,
	withMobileDialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	Button,
} from '@material-ui/core'
import { toggleErrorsDialog } from 'actions/view'
import { Link } from 'react-router-dom'
import * as routes from 'components/routes'

const entitiesWithRoutes = {
	campaign: { label: 'campaign', endpoint: 'campaigns', route: 'campaign' },
	task: { label: 'task', endpoint: 'tasks', route: 'task' },
	contact: { label: 'contact', endpoint: 'contacts', route: 'contact' },
	signupform: { label: 'signup form', endpoint: 'forms', route: 'signupform' },
	contactgroup: {
		label: 'contact group',
		endpoint: 'contactgroups',
		route: 'group',
	},
	template: { label: 'template', endpoint: 'templates', route: 'template' },
}

const humanReadable = (message) => {
	const obj = {
		'campaign status: only W (Work In Progress) and C (Completed) campaigns can be deleted':
			"Only campaigns that are 'work in progress' or 'completed' can be deleted. Please change the status in order to delete this campaign",
		'mobile_number should match pattern "^\\+1[1-9][0-9]{9}$"':
			'The phone number you entered is not properly formatted, please try again.',
		'should match pattern "^\\+1[1-9][0-9]{9}$"':
			'Must match pattern (ex: +1 (215) 000-0000)',
		'one or more json schema validaiton errors has occurred. See: [/schema/email/template/POST/request]':
			'Your email template fields have errors.',
		'Template.SubjectPart: String length must be greater than or equal to 1':
			'Your email template subject cannot be blank.',
		'name: String length must be greater than or equal to 1':
			'Your email template name cannot be blank.',
	}

	return obj[message] || message
}

const EntityLink = connect(
	(state, { error }) => ({
		list: routes[entitiesWithRoutes[error.referring_type].route].listState
			? routes[entitiesWithRoutes[error.referring_type].route].listState(state)
			: state.data[entitiesWithRoutes[error.referring_type].route],
	}),
	null,
)(({ error, list }) => (
	<Fragment>
		{error && error.referring_type && error.referring_id ? (
			<Fragment>
				{list && error.referring_id && list[error.referring_id]
					? `the ${entitiesWithRoutes[error.referring_type].label}, `
					: ''}
				<Link
					to={`/${entitiesWithRoutes[error.referring_type].endpoint}/${
						error.referring_id
					}`}
				>
					{list && error.referring_id && list[error.referring_id]
						? list[error.referring_id].name
						: `this ${entitiesWithRoutes[error.referring_type].label}`}
				</Link>
			</Fragment>
		) : (
			'an entity'
		)}
	</Fragment>
))

const ErrorsDialog = ({
	fullScreen,
	toggleErrorsDialog,
	errors,
	errorsEntity,
	message,
	open,
}) => (
	<Dialog
		fullScreen={fullScreen}
		open={open}
		aria-labelledby="responsive-dialog-title"
		style={{ borderRadius: 22 }}
	>
		<DialogTitle id="responsive-dialog-title">{message}</DialogTitle>
		<DialogContent>
			{errors && errors.message ? (
				<DialogContentText>{`Error message: ${humanReadable(
					errors.message,
				)}`}</DialogContentText>
			) : null}
			{errors &&
			errors.message === 'delete dependency' &&
			errors.additional_errors ? (
				<DialogContentText>
					<ul>
						{errors.additional_errors
							.filter(
								(error) =>
									error.referring_type &&
									entitiesWithRoutes[error.referring_type],
							)
							.map((error) =>
								error.message ? (
									<li>
										{error.message.slice(0, 13) === 'object in use' ? (
											<Fragment>
												{`Cannot delete this ${errorsEntity}, it is in use by `}
												<EntityLink error={error} />
											</Fragment>
										) : (
											humanReadable(error.message)
										)}
									</li>
								) : null,
							)}
					</ul>
				</DialogContentText>
			) : errors && errors.additional_errors ? (
				<ul>
					{errors.additional_errors.map((error) => (
						<li>{humanReadable(error.message)}</li>
					))}
				</ul>
			) : null}
		</DialogContent>
		<DialogActions>
			<Button
				autoFocus
				onClick={() => {
					toggleErrorsDialog()
				}}
				color="secondary"
			>
				Ok
			</Button>
		</DialogActions>
	</Dialog>
)

export default connect(
	(state) => ({
		errors: state.error.errors,
		errorsEntity: state.error.errorsEntity,
		message: state.snackbar.message,
		open: state.error.dialogOpen,
	}),
	(dispatch) => bindActionCreators({ toggleErrorsDialog }, dispatch),
)(withMobileDialog()(ErrorsDialog))
